/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class ProvidersModule
 */
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { Provider } from '@/modules/backend/Entities/Provider';
import homeSmartApi from '@/plugins/HomeSmartApi';
import { CreateProviderData } from '@/modules/backend/Dto/CreateProviderData';
import { EditProviderData } from '@/modules/backend/Dto/EditProviderData';

@Module({ namespaced: true, store, name: 'dashboard/providers' })
export default class ProvidersModule extends VuexModule {
  public get providers(): Provider[] {
    return this.items;
  }

  public get isLoading(): boolean {
    return this.loading;
  }

  private items: Provider[] = [];

  private loading = false;

  @Action
  public async fetch(): Promise<Provider[]> {
    this.context.commit('setLoading', true);
    const providers: Provider[] = await homeSmartApi.Providers.fetch();
    this.context.commit('set', providers);
    this.context.commit('setLoading', false);
    return providers;
  }

  @Action
  public async create(data: CreateProviderData): Promise<Provider> {
    const provider = await homeSmartApi.Providers.create(data);
    this.context.commit('add', provider);
    return provider;
  }

  @Action
  public async edit(data: EditProviderData): Promise<Provider> {
    const provider = await homeSmartApi.Providers.edit(data);
    this.context.commit('replace', provider);
    return provider;
  }

  @Action
  public async remove(providerId: number): Promise<void> {
    await homeSmartApi.Providers.remove(providerId);
    this.context.commit('remove', providerId);
  }

  @Mutation
  private set(providers: Provider[]): void {
    this.items = providers;
  }

  @Mutation
  private add(provider: Provider): void {
    this.items = this.items.concat(provider);
  }

  @Mutation
  private unset(id: number): void {
    this.items = this.items.filter((item) => item.getId() === id);
  }

  @Mutation
  private replace(provider: Provider): void {
    this.items = this.items.map((item) => item.getId() === provider.getId() ? provider : item);
  }

  @Mutation
  private setLoading(loading: boolean): void {
    this.loading = loading;
  }
}
